'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    boardBodyStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dofBoardWrapperStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || (this._isDiablo ? 'diablo' : 'default');
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    _boardBodyStyle: function _boardBodyStyle() {
      var tmp = { backgroundColor: this.themeStyle.backgroundColor };
      var style = _extends({
        paddingLeft: '31px',
        paddingRight: '31px',
        paddingTop: '32px',
        paddingBottom: '32px'
      }, tmp, this.boardBodyStyle);
      return style;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-board/index.vue
// module id = 303
// module chunks = 0 1